// extracted by mini-css-extract-plugin
export var scrollArea = "_py-0";